/*
 * Laboté — moteur de la Consultation Sur-Mesure (P1)
 * Reproduit à l'identique l'algorithme du quiz /pages/sur-mesure (source :
 * consultation-beaute/reference/ALGO-QUIZ-LABOTE.md + quiz_questions.json) :
 * accumulation d'actifs par produit avec déduplication, overrides (cycle,
 * ménopause, enceinte/allergies), code type de peau O+D+q(+B), variantes,
 * payloads panier/worker/Klaviyo. Aucune dépendance UI ; exécutable sous Node.
 */
(function (root) {
  'use strict';

  var DATA = (root && root.LaboteQuizData) ||
    (typeof module !== 'undefined' && typeof require === 'function' ? require('./consultation-data.js') : []);

  var PRODUCTS = ['daily_cream', 'night_cream', 'serum', 'eye_contour'];
  var WORKER_URL = 'https://labote-quiz-metafields.princekamboj7500.workers.dev/save-quiz';

  // Normalisation des noms d'actifs — copie de la table `pt` du bundle de prod
  var NORMALIZE = {
    'ACEROLA': 'Acérola', 'Acerola': 'Acérola', 'acérola': 'Acérola',
    'collagene': 'Collagène', 'COLLAGENE': 'Collagène',
    'Huile de Nigelle': 'Nigelle', 'huile de nigelle': 'Nigelle',
    'Camelia': 'Camélia', 'camelia': 'Camélia',
  };
  function normalizeName(n) { return NORMALIZE[n] || n; }

  // --- Questions ---
  function questionsFor(product) {
    return DATA.filter(function (q) { return (q.products || []).indexOf(product) !== -1; });
  }
  function findQuestion(qid) {
    // certaines questions de prod n'ont pas de question_id (genre, inputs) → match aussi sur le libellé
    var matches = function (q) { return q.question_id === qid || q.question === qid; };
    for (var i = 0; i < DATA.length; i++) {
      if (matches(DATA[i])) return DATA[i];
      var answers = DATA[i].answers || [];
      for (var j = 0; j < answers.length; j++) {
        var subs = answers[j].questions || [];
        for (var k = 0; k < subs.length; k++) { if (matches(subs[k])) return subs[k]; }
      }
    }
    return null;
  }

  // Libellés exacts pilotant sauts et overrides (iso bundle de prod)
  var OPT = {
    noConcern: 'Aucune préoccupation de peau',
    cycleButtons: ['Occasionnellement selon mon cycle menstruel', 'Ponctuellement'],
    menopause: 'Ménopause / pré-ménopause',
    pregnant: 'Enceinte / allaitante',
    allergic: 'Ma peau réagit très souvent et est sujette aux allergies',
    eyeContactReaction: 'Ma peau a déjà mal réagi uniquement au niveau du contour des yeux',
  };
  var SKIN_TYPE_QID = 'Yqik23N';
  var CONCERN_MAIN_QIDS = ['N1iez3V', '701'];
  var CONCERN_SECOND_QIDS = ['wLiW3Jq', '801'];
  var BUTTONS_PARENT = 'Boutons / Mycrokystes';

  // Texte Marula appliqué par l'override Ménopause (copie du bundle)
  var MENOPAUSE_TEXT = "de plus en plus sèche lors de la pré-ménopause ou ménopause en raison de la " +
    "diminution des oestrogènes. Nous avons sélectionné l'huile de marula riche en omega-9, elle nourrit et protège la peau.";

  // Combien de questions sauter après cette réponse (iso bundle : +2 / +1)
  function skipAfter(qid, option) {
    if (option !== OPT.noConcern) return 0;
    if (CONCERN_MAIN_QIDS.indexOf(qid) !== -1) return 2;
    if (CONCERN_SECOND_QIDS.indexOf(qid) !== -1) return 1;
    return 0;
  }

  /*
   * `collected` : liste ordonnée de réponses construites par l'UI —
   * { qid, question, group, option, parentOption?, ing: {daily_cream:[…],…}, content: {…} }
   * (ing/content = copies des champs de la réponse dans les données ; les inputs
   * libres — date, personnalisations — n'ont pas de `ing`.)
   */
  function record(question, answer, parentOption) {
    var ing = {};
    PRODUCTS.forEach(function (p) { ing[p] = (answer[p] || []).slice(); });
    return {
      qid: question.question_id || question.question,
      question: question.question,
      group: question.group || '',
      option: answer.option,
      parentOption: parentOption || null,
      ing: ing,
      content: answer.content || {},
    };
  }

  function hasOption(collected, option) {
    return collected.some(function (r) { return r.option === option; });
  }

  // Overrides rétroactifs — retourne une copie de travail des enregistrements
  function applyOverrides(collected) {
    var work = collected.map(function (r) {
      return { qid: r.qid, question: r.question, group: r.group, option: r.option,
        parentOption: r.parentOption,
        ing: PRODUCTS.reduce(function (o, p) { o[p] = (r.ing && r.ing[p] || []).slice(); return o; }, {}),
        content: r.content || {} };
    });
    var skinType = work.find(function (r) { return r.qid === SKIN_TYPE_QID; });
    var cycleBtn = work.find(function (r) {
      return r.parentOption === BUTTONS_PARENT && OPT.cycleButtons.indexOf(r.option) !== -1;
    });
    // 1. Boutons cycle/ponctuels : la réponse type de peau ne compte plus
    //    (les actifs Jojoba/Nigelle arrivent déjà par la sous-réponse boutons)
    if (cycleBtn && skinType) { PRODUCTS.forEach(function (p) { skinType.ing[p] = []; }); }
    // 2. Ménopause : Marula jour + sérum à la place du type de peau, cycle annulé
    if (hasOption(work, OPT.menopause)) {
      if (skinType) {
        skinType.ing.daily_cream = ['Marula'];
        skinType.ing.serum = ['Marula'];
        skinType.content = Object.assign({}, skinType.content, {
          daily_cream: { 'Marula': MENOPAUSE_TEXT },
          serum: { 'Marula': MENOPAUSE_TEXT },
        });
      }
      if (cycleBtn) { cycleBtn.ing.daily_cream = []; cycleBtn.ing.serum = []; }
    }
    return work;
  }

  // Accumulation avec déduplication + normalisation (iso bundle)
  function computeResultIngredients(collected) {
    var work = applyOverrides(collected);
    var result = {};
    PRODUCTS.forEach(function (p) { result[p] = []; });
    work.forEach(function (r) {
      PRODUCTS.forEach(function (p) {
        (r.ing[p] || []).forEach(function (name) {
          var n = normalizeName(name);
          if (result[p].indexOf(n) === -1) result[p].push(n);
        });
      });
    });
    // 3. Ménopause retire le Jojoba jour + sérum du résultat final
    if (hasOption(collected, OPT.menopause)) {
      ['daily_cream', 'serum'].forEach(function (p) {
        result[p] = result[p].filter(function (n) { return n !== 'Jojoba'; });
      });
    }
    return result;
  }

  // Paires {ingredient, description} pour le produit sélectionné (argumentation)
  function ingredientsInfo(collected, product) {
    var work = applyOverrides(collected);
    var seen = {};
    var out = [];
    work.forEach(function (r) {
      (r.ing[product] || []).forEach(function (name) {
        var n = normalizeName(name);
        if (seen[n]) return;
        seen[n] = true;
        var byProduct = (r.content || {})[product] || {};
        out.push({ ingredient: n, description: byProduct[name] || byProduct[n] || '', from: r.option, qid: r.qid });
      });
    });
    if (hasOption(collected, OPT.menopause)) {
      out = out.filter(function (i) { return !(i.ingredient === 'Jojoba' && (product === 'daily_cream' || product === 'serum')); });
      // le Marula imposé par l'override vient de la ménopause, pas du type de peau déclaré
      out.forEach(function (i) {
        if (i.ingredient === 'Marula' && i.qid === SKIN_TYPE_QID) i.from = OPT.menopause;
      });
    }
    return out;
  }

  // --- Code type de peau O+D+q(+B) — conditions du bundle reproduites telles quelles,
  // y compris « au repros » (coquille de prod : la condition rides profondes ne matche
  // jamais ; la corriger changerait les codes envoyés au laboratoire).
  var TYPE_CODES = [
    ["Malgré l'application de soins (hors matifiant), ma peau a un aspect brillant et luisant surtout sur la zone front, nez, menton.", '1G'],
    ['Je ne ressens rien de particulier, ma peau peut briller sur la zone front, nez, menton en fin de journée.', '2E'],
    ["Même sans soin, je ne ressens rien de particulier et je n'ai pas constaté de brillance ou d'inconfort.", '3E'],
    ["J'ai besoin d'appliquer des textures légères pour que ma peau soit confortable toute la journée.", '4E'],
    ['Ma peau a tendance "à boire" les soins appliqués. J\'ai besoin d\'appliquer des textures épaisses pour que ma peau reste confortable toute la journée.', '5S'],
    ["Malgré l'application de soins, ma peau peut être inconfortable et tiraille dans la journée. Elle a tendance a manquer de douceur.", '6S'],
  ];
  var SENSITIVE_2 = [
    'Des rougeurs permanentes et diffuses : couperose / acné rosacée',
    'Dermatite séborrhéique (symptômes : des plaques rouges recouvertes de pélicules blanches majoritairement au niveau des ailes du nez et des sourcils)',
    'Psoriasis (symptômes : des plaques épaisses rouges recouvertes de squames argentés)',
  ];
  var SENSITIVE_1 = ["Des rougeurs d'irritation, démangeaisons", 'Des rougeurs occasionnelles', 'Non'];
  var WRINKLES_PLUS = [
    'De fines ridules qui apparaissent occasionnellement sur le front ou le contour des yeux (souvent lorsque ma peau tiraille)',
    "Des rides d'expression qui dispaissent au repos",
    'Des rides visibles même au repos',
    'Des rides profondes visibles au repros accompagnées de zones de relâchement', // coquille de prod conservée
    'Rien de tout ça, mais je veux travailler en prévention',
  ];
  var SKIN_TYPE_WITH_SUFFIX = ['0G0++', '0G1++', '1G0++', '1G1++',
    '2E0+', '2E0++', '2E1+', '2E1++', '2E2+', '2E2++',
    '3E0+', '3E0++', '3E1+', '3E1++', '3E2+', '3E2++',
    '4E0+', '4E0++', '4E1+', '4E1++', '4E2+', '4E2++'];

  function skinCode(collected) {
    // Iso bundle : C = réponses du groupe concerns, n = type de peau, E = moment de vie, S = réactions
    // (les conditions sont scopées — « Non » à la question tabac ne doit pas rendre la peau sensible)
    var concerns = collected.filter(function (r) { return r.group === 'concerns'; })
      .map(function (r) { return r.option; });
    var reactions = collected.filter(function (r) { return r.group === 'reactions'; })
      .map(function (r) { return r.option; });
    var moments = collected.filter(function (r) { return r.group === 'moment_of_life'; })
      .map(function (r) { return r.option; });
    var skinTypeRec = collected.find(function (r) { return r.qid === SKIN_TYPE_QID; });
    var st = skinTypeRec ? skinTypeRec.option : '';
    var O = '';
    var eczema = concerns.some(function (o) { return o && o.indexOf('Eczéma / Dermatite atopique') === 0; });
    if (eczema) O = '5S';
    else if (concerns.indexOf("En permanence ou fréquemment sur l'ensemble du visage") !== -1 ||
      st.indexOf('Ma peau est acnéique') === 0) O = '0G';
    else {
      for (var i = 0; i < TYPE_CODES.length; i++) {
        if (st === TYPE_CODES[i][0]) { O = TYPE_CODES[i][1]; break; }
      }
    }
    var D = '0';
    var sensitive2 = reactions.indexOf(OPT.allergic) !== -1 || eczema ||
      SENSITIVE_2.some(function (o) { return concerns.indexOf(o) !== -1; });
    if (sensitive2) D = '2';
    else if (SENSITIVE_1.some(function (o) { return concerns.indexOf(o) !== -1; })) D = '1';
    var q = '+';
    if (moments.indexOf(OPT.menopause) !== -1 ||
      WRINKLES_PLUS.some(function (o) { return concerns.indexOf(o) !== -1; })) q = '++';
    var group = O + D + q;
    var type = group;
    if (concerns.indexOf('Brillances') !== -1 && SKIN_TYPE_WITH_SUFFIX.indexOf(group) !== -1) type = group + 'B';
    return { skinGroup: group, skinType: type };
  }

  // --- Conseils sans parfum (enceinte / allergies) ---
  function fragranceAdvice(collected) {
    var out = [];
    if (hasOption(collected, OPT.pregnant)) out.push('pregnant');
    if (hasOption(collected, OPT.allergic)) out.push('allergic');
    return out;
  }

  // --- Personnalisation : textures / parfums / variantes ---
  var TEXTURES_ALLOWED = {
    daily_cream: ['onctueuse sans effet gras', 'légère sans effet de matière', 'gel crème', 'riche sans effet gras'],
    night_cream: ['onctueuse sans effet gras', 'riche sans effet gras'],
    serum: [], eye_contour: [],
  };
  var TEXTURE_VARIANT = {
    'onctueuse sans effet gras': 'Onctueuse',
    'légère sans effet de matière': 'Légère',
    'gel crème': 'Gel crème',
    'riche sans effet gras': 'Riche',
  };
  var FRAGRANCE_VARIANT = { 'Figuier': 'Figuier', 'Tiaré': 'Tiaré', 'Aucun parfum': 'Sans parfum', 'figuier': 'Figuier' };

  // Libellé long du quiz → clé de texture interne
  function textureKeyFromOption(option) {
    var head = String(option || '').split(',')[0].trim().toLowerCase();
    if (head === 'onctueuse') return 'onctueuse sans effet gras';
    if (head === 'légère') return 'légère sans effet de matière';
    if (head === 'gel crème') return 'gel crème';
    if (head === 'riche') return 'riche sans effet gras';
    return null;
  }

  function getProduct(productKey, config) {
    var products = (config || (root && root.LaboteConfig) || {}).products || {};
    return products[productKey] || null;
  }

  function variantFor(productKey, fragrance, textureKey, config) {
    var p = getProduct(productKey, config);
    if (!p || !p.variants || !p.variants.length) return null;
    var wantFragrance = FRAGRANCE_VARIANT[fragrance] || FRAGRANCE_VARIANT[String(fragrance || '').toLowerCase()] || null;
    var wantTexture = textureKey ? TEXTURE_VARIANT[textureKey] : null;
    var match = p.variants.find(function (v) {
      var opts = v.options || [];
      var okF = !wantFragrance || opts.indexOf(wantFragrance) !== -1;
      var okT = !wantTexture || opts.indexOf(wantTexture) !== -1;
      return okF && okT;
    });
    return match || p.variants[0];
  }

  // --- Payloads (iso quiz de prod) ---
  function answersForQuizData(collected) {
    return collected.map(function (r) { return { question: r.question, answer: r.option }; });
  }

  function buildQuizData(state) {
    var product = state.product;
    var result = computeResultIngredients(state.collected);
    var code = skinCode(state.collected);
    return {
      firstName: state.firstName || '',
      product: [product],
      skinType: code.skinType,
      skinGroup: code.skinGroup,
      ingredients: result[product] || [],
      resultIngredients: result,
      fragrance: state.fragrance || 'figuier',
      texture: state.texture || 'onctueuse sans effet gras',
      resultContent: state.resultContent || null,
      answers: answersForQuizData(state.collected),
      nameOnBox: state.nameOnBox || '',
      note: state.note || '',
      additionalInformation: state.additionalInformation || '',
      dateOfBirth: state.dateOfBirth || '',
      savedAt: new Date().toISOString(),
      source: 'consultation-sur-mesure',
    };
  }

  function buildCartItem(state, config) {
    var product = state.product;
    var result = computeResultIngredients(state.collected);
    var isCream = product === 'daily_cream' || product === 'night_cream';
    var variant = variantFor(product, state.fragrance, isCream ? state.texture : null, config);
    if (!variant) return null;
    var properties = {
      '_ingredients': JSON.stringify(result[product] || []),
      // _quizdata reste un tableau structuré (iso quiz de prod) : le backend labo
      // le reçoit tel quel sur la commande — ne pas stringifier.
      '_quizdata': answersForQuizData(state.collected),
    };
    if (isCream) {
      properties['fragrance'] = state.fragrance || 'figuier';
      properties['texture'] = state.texture || 'onctueuse sans effet gras';
    }
    return { id: variant.id, quantity: 1, properties: properties };
  }

  var PRODUCT_LABELS_FR = {
    daily_cream: 'crème de jour', night_cream: 'crème de nuit',
    serum: 'sérum', eye_contour: 'contour des yeux',
  };

  function buildKlaviyoProps(state) {
    var product = state.product;
    var result = computeResultIngredients(state.collected);
    var concerns = state.collected
      .filter(function (r) { return r.group === 'concerns'; })
      .map(function (r) { return { question: r.question, group: r.group, answer: r.option }; });
    var props = {
      customized_product_selected: PRODUCT_LABELS_FR[product] || product,
      customized_product_description: state.resultText || '',
      customer_skincare_concerns: concerns,
      active_ingredients: result[product] || [],
      resulted_ingredients: result,
      customerName: state.firstName || '',
      consultation_input_method: state.inputMethod || 'questions',
    };
    if (product === 'daily_cream' || product === 'night_cream') {
      props.fragrance = state.fragrance || 'figuier';
      props.texture = state.texture || 'onctueuse sans effet gras';
    }
    return props;
  }

  // Synthèse produit — squelettes des templates de prod, actifs réels, aucun claim inventé
  function resultText(state) {
    var product = state.product;
    var result = computeResultIngredients(state.collected);
    var actifs = (result[product] || []).join(', ');
    var frag = state.fragrance === 'Aucun parfum' ? 'sans parfum'
      : 'avec le parfum ' + String(state.fragrance || 'figuier').toLowerCase();
    var texture = (state.texture || 'onctueuse sans effet gras').split(' ')[0];
    if (product === 'daily_cream') {
      return 'Votre crème de jour sur-mesure protège votre peau la journée. Elle est enrichie en ' + actifs +
        '. Rien que pour vous, elle est formulée à la demande ' + frag +
        '. La texture de votre crème de jour sur-mesure est ' + texture + '. 97% d\'origine naturelle';
    }
    if (product === 'night_cream') {
      return 'Votre crème de nuit sur-mesure accompagne le renouvellement de votre peau pendant la nuit. Elle est enrichie en ' + actifs +
        '. Rien que pour vous, elle est formulée à la demande ' + frag +
        '. La texture de votre crème de nuit sur-mesure est ' + texture + '. 97% d\'origine naturelle';
    }
    if (product === 'serum') {
      return 'Votre sérum sur-mesure renforce l\'efficacité de vos crèmes, offrant une double dose d\'actifs. Il est enrichi en ' + actifs +
        '. La texture de votre sérum sur-mesure est fluide pour optimiser sa pénétration dans la peau. 98% d\'origine naturelle';
    }
    return 'Votre soin sur-mesure est enrichi en ' + actifs + '.';
  }

  // --- Réseau / tracking (navigateur uniquement — jamais bloquant) ---
  function track(eventName, properties) {
    try {
      root._learnq = root._learnq || [];
      root._learnq.push(['track', eventName, Object.assign({ source: 'consultation-sur-mesure', page_url: root.location ? root.location.href : '' }, properties)]);
    } catch (e) { /* le suivi ne casse jamais le parcours */ }
  }
  function identify(properties) {
    try { root._learnq = root._learnq || []; root._learnq.push(['identify', properties]); } catch (e) { /* idem */ }
  }
  // Inscription à la liste bienvenue (API client Klaviyo, clé publique) —
  // déclenche le flow « Added to List » qui envoie l'offre par email (code jamais affiché).
  function subscribeWelcome(email, firstName, listId, companyId) {
    if (!root || !root.fetch || !email || !listId || !companyId) return Promise.resolve(false);
    var attributes = { email: email };
    if (firstName) attributes.first_name = firstName;
    return root.fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(companyId), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2025-04-15' },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'Consultation Sur-Mesure',
            profile: { data: { type: 'profile', attributes: attributes } },
          },
          relationships: { list: { data: { type: 'list', id: listId } } },
        },
      }),
    }).then(function (r) { return r.status === 202 || r.ok; }).catch(function () { return false; });
  }

  function postWorker(email, quizData) {
    if (!root || !root.fetch) return Promise.resolve(null);
    return root.fetch(WORKER_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: email, quizData: quizData }),
    }).then(function (r) { return r.json(); }).catch(function () { return null; });
  }
  function addToCart(state, config) {
    var item = buildCartItem(state, config);
    if (!item || !root || !root.fetch) return Promise.reject(new Error('Variante introuvable'));
    return root.fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [item], sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: root.location ? root.location.pathname : '/' }),
    }).then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); });
  }

  var api = {
    DATA: DATA, PRODUCTS: PRODUCTS, OPT: OPT, PRODUCT_LABELS_FR: PRODUCT_LABELS_FR,
    TEXTURES_ALLOWED: TEXTURES_ALLOWED, TEXTURE_VARIANT: TEXTURE_VARIANT, FRAGRANCE_VARIANT: FRAGRANCE_VARIANT,
    WORKER_URL: WORKER_URL,
    normalizeName: normalizeName, questionsFor: questionsFor, findQuestion: findQuestion,
    skipAfter: skipAfter, record: record,
    applyOverrides: applyOverrides, computeResultIngredients: computeResultIngredients,
    ingredientsInfo: ingredientsInfo, skinCode: skinCode, fragranceAdvice: fragranceAdvice,
    textureKeyFromOption: textureKeyFromOption, getProduct: getProduct, variantFor: variantFor,
    buildQuizData: buildQuizData, buildCartItem: buildCartItem, buildKlaviyoProps: buildKlaviyoProps,
    resultText: resultText,
    track: track, identify: identify, postWorker: postWorker, addToCart: addToCart,
    subscribeWelcome: subscribeWelcome,
  };

  if (root) root.LaboteEngine = api;
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
})(typeof window !== 'undefined' ? window : (typeof globalThis !== 'undefined' ? globalThis : this));
